module.exports = __webpack_public_path__ + "media/images/loading-4fb4a77a38f9dbe7f130ea034b91cc21.gif";